import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LegalBlocks } from './LegalBlocks';

const Section = styled.section`
  margin-bottom: 2rem;
`;
const SectionTitle = styled.h2`
  color: var(--brand-blue);
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  border-bottom: 2px solid var(--brand-red);
  padding-bottom: 0.35rem;
`;
const Subtitle = styled.h3`
  color: var(--brand-red);
  font-size: 1rem;
  margin: 1rem 0 0.5rem 0;
`;
const P = styled.p`
  margin-bottom: 0.75rem;
  text-align: justify;
`;
const List = styled.ul`
  margin: 0.5rem 0;
  padding-left: 1.5rem;
`;
const Li = styled.li`
  margin-bottom: 0.35rem;
`;
const ContactBlock = styled.div`
  background: var(--bg-secondary, #f5f5f5);
  padding: 1rem 1.25rem;
  border-radius: 8px;
  border-left: 4px solid var(--brand-blue);
  margin: 1rem 0;
  white-space: pre-line;
`;

/**
 * Full Terms & Conditions from locale bundles (`termsWebsite.sections`).
 * Used on /terms-and-conditions and in registration modals.
 */
const TermsContent = () => {
  const { t } = useTranslation();
  const sections = t('termsWebsite.sections', { returnObjects: true });

  if (!Array.isArray(sections)) {
    return null;
  }

  const ui = { P, List, Li, Subtitle, ContactBlock };

  return (
    <>
      {sections.map((sec, i) => (
        <Section key={i}>
          {sec.title ? <SectionTitle>{sec.title}</SectionTitle> : null}
          <LegalBlocks blocks={sec.blocks} ui={ui} />
        </Section>
      ))}
    </>
  );
};

export default TermsContent;
